export default {
  "content": "<g fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path d=\"M11 5.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S13.33 7 12.5 7 11 6.33 11 5.5zm1 0c0 .28.22.5.5.5s.5-.22.5-.5-.22-.5-.5-.5-.5.22-.5.5z\"/><path d=\"M1 2h14c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1zm0 7.71V13h6.99L2.88 7.88l-.04-.03L1 9.71zm6.05.94L9.4 13h3.59L8.88 8.88l-.04-.03-1.75 1.76-.04.04zM14.4 13h.6V3H1v5.29l1.49-1.5c.2-.19.51-.19.71 0l3.14 3.15 2.15-2.15c.2-.19.51-.19.71 0L14.4 13z\"/></g>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};